const listeners = new Set();
export const subscribeAvailabilityErrors = listener => { listeners.add(listener); return () => listeners.delete(listener); };

// Observe only first-party API transport/server failures, with no request body,
// URL, bearer or response text. This observer never changes the caller's error
// or retries its mutation. Public probes are excluded to prevent feedback loops.
export function observeAvailabilityError(error, configuredBaseURL) {
  const config = error.config;
  if (!config?.url || config.__serviceAvailabilityProbe || error.code === 'ERR_CANCELED') return;
  let url, api;
  try {
    api = new URL(configuredBaseURL || window.location.origin, window.location.origin);
    url = new URL(config.url, config.baseURL || api);
  } catch { return; }
  if (url.origin !== api.origin || !url.pathname.startsWith('/api/')) return;
  const status = error.response?.status;
  const transport = !error.response && ['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT'].includes(error.code);
  if (!transport && ![500, 502, 503, 504].includes(status)) return;
  const suppliedCode = error.response?.data?.error?.code || error.response?.data?.code;
  const event = { status: status || null, code: status === 503 && suppliedCode === 'SERVICE_MAINTENANCE' ? 'SERVICE_MAINTENANCE' : null };
  for (const listener of listeners) {
    try { listener(event); } catch { /* Observation must not replace the original API outcome. */ }
  }
}
